<div class="fc-product-heading-background"></div>
<h1 [innerHtml]="heading"></h1>
<h2 [innerHtml]="page.product.varianceTitle"></h2>
<div class="fc-product-description" [innerHtml]="page.product.description | marked"></div>
<fc-product-action [pageDetails]="page" [compareButtonText]="page.compareButtonText"></fc-product-action>
<fc-product-advert [product]="page" [pageDetails]="page" [showHeading]="false" ></fc-product-advert>
<fc-product-content [page]="page" [applySettings]="applySettings" [categoryUrl]="categoryUrl" ></fc-product-content>
